/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 17/12/2020
 */

import {
    procedureInCartRequest,
    addToCartRequest,
    numberOfItemsRequest,
    cartBaseRequest,
    procedureAllItemsRequest,
    procedureMoveRequest,
    cart2Request,
    cart3Request
} from "./../api/models";
import {Cart} from "./../api";
import {toFormDataForCart} from "./../core/utils";
//import router from "@/router";

const cartModule = {
    namespaced: true,
    state: {
        isProcedureInCart: false,
        numberCartItems: 0,
        cartData: null,
        proceduresInCart: null,
        proceduresInWishList: null,
        cart2Data: null,
        cart2DataDetails: null,
        cartStep: 1,

        cart3Data: null
    },
    getters: {
        countCheckoutItems: state => {
            return state.cartData.tramitesCheckoutItems
        },
        countCheckout2Items: state => {
            return state.cart2Data.tramitesCheckoutItems
        }
    },
    actions: {
        async getIsProcedureInCart({dispatch, commit}, request = procedureInCartRequest()){
            dispatch('alerts/showLoading', 'Consultando información del portafolio.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.postIsProcedureInCart(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setIsProcedureInCart', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getNumberOfItems({dispatch, commit}, request = numberOfItemsRequest()){
            //dispatch('alerts/showLoading', 'Consultando número de trámites en el portafolio.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.getNumberOfItems(toFormDataForCart(request))
                .then(data => {
                    //dispatch('alerts/hideLoading', null, { root: true })
                    commit('setNumberOfItems', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async addProcedureToCart({dispatch, commit}, request = addToCartRequest()){
            dispatch('alerts/showLoading', 'Agregando el trámite al portafolio.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.addProcedureToCart(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    if (data.success){
                        dispatch('alerts/success', data.message,  { root: true })
                        commit('addProcedureToCartSuccess')

                        dispatch('cart/getNumberOfItems', numberOfItemsRequest(), { root: true })
                    }else{
                        dispatch('alerts/error', data.message,  { root: true })
                    }

                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getCartStep1({dispatch, commit}, request = cartBaseRequest()){
            dispatch('alerts/showLoading', 'Obteniendo información del portafolio.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.getCartStep1(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    //console.log(JSON.stringify(data))
                    commit('setCartStep1Data', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getProcedureAllItems({dispatch, commit}, request = procedureAllItemsRequest()){
            dispatch('alerts/showLoading', 'Obteniendo detalles del trámite.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.getProcedureAllItems(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('showProcedureAllItems', {
                        result: data,
                        procedureIndex: request.procedure_index,
                        procedureType: request.procedure_type
                    })

                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async moveProcedureToCart({dispatch}, request = procedureMoveRequest()){
            dispatch('alerts/showLoading', 'Moviendo el trámite a la listado de pagos.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.moveProcedureToCart(toFormDataForCart(request))
                // eslint-disable-next-line no-unused-vars
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('cart/getCartStep1', null, { root: true })
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async moveProcedureToWishlist({dispatch}, request = procedureMoveRequest()){
            dispatch('alerts/showLoading', 'Moviendo el trámite a la lista de espera.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.moveProcedureToWishlist(toFormDataForCart(request))
                // eslint-disable-next-line no-unused-vars
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('cart/getCartStep1', null, { root: true })
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getCheckoutAllItems({dispatch, commit}, request = cartBaseRequest()){
            dispatch('alerts/showLoading', 'Obteniendo toda la información de la trasancción.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.getCheckoutAllItems(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('showCheckoutAllItems', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async removeProcedureItem({dispatch}, request = procedureMoveRequest()){
            dispatch('alerts/showLoading', 'Removiendo trámite del portafolio.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Cart.removeItem(toFormDataForCart(request))
                // eslint-disable-next-line no-unused-vars
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('cart/getCartStep1', null, { root: true })
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getCartStep2({dispatch, commit}, request = cart2Request()) {
            dispatch('alerts/showLoading', 'Obteniendo información del paso 2 del portafolio.', {root: true})
            await dispatch('account/checkAuthExpiration', null, {root: true})

            Cart.getCartStep2(toFormDataForCart(request))
                .then(data => {
                    // console.log(JSON.stringify(data))
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setCartStep2Data', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                    //router.push({name: 'portfolio', params:{step: 1}}) @TODO
                    dispatch('alerts/redirect', {name: 'portfolio', params:{step: 1}}, {root: true})
                })
        },

        async getCart2Details({dispatch, commit}, request = cart2Request()){
            dispatch('alerts/showLoading', 'Obteniendo todos los tramites.', {root: true})
            await dispatch('account/checkAuthExpiration', null, {root: true})

            commit('setCart2Details', null)

            Cart.getCart2Details(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setCart2Details', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getCartStep3({dispatch, commit}, request = cart3Request()){
            dispatch('alerts/showLoading', 'Obteniendo información del paso 3.', {root: true})
            await dispatch('account/checkAuthExpiration', null, {root: true})

            Cart.getCartStep3(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setCartStep3Data', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        }

    },
    mutations: {
        setIsProcedureInCart(state, data){
            state.isProcedureInCart = data.has_procedure
        },
        addProcedureToCartSuccess(state){
            state.isProcedureInCart = true
        },
        setNumberOfItems(state, data){
            state.numberCartItems =  data.cart_n_items
        },
        setCartStep1Data(state, data){
            state.cartStep = 1
            state.cartData = data
        },
        showProcedureAllItems(state, data){
            console.log(JSON.stringify(data))
            if (data.procedureType === 'cart'){
                state.cartData.tramitesCarrito[data.procedureIndex].tramitesCarrito = data.result.tramitesCarrito
                state.cartData.tramitesCarrito[data.procedureIndex].totalTramitesCarrito = 0
            }else if (data.procedureType === 'wishlist'){
                state.cartData.wishList[data.procedureIndex].tramitesCarrito = data.result.tramitesCarrito
                state.cartData.wishList[data.procedureIndex].totalTramitesCarrito = 0
            }

        },
        // eslint-disable-next-line no-unused-vars
        showCheckoutAllItems(state, data){
            if (state.cartStep === 1){
                state.cartData.tramitesCheckout = data.tramitesCheckout
                state.cartData.tramitesCheckoutItems = 0
            }else if (state.cartStep === 2){
                state.cart2Data.tramitesCheckout = data.tramitesCheckout
                state.cart2Data.tramitesCheckoutItems = 0
            }
        },

        setCartStep2Data(state, data){
            state.cartStep = 2
            state.cart2Data = data
        },

        setCart2Details(state, data){
            state.cart2DataDetails = data
        },

        setCartStep3Data(state, data){
            state.cart3Data = data
        }
    }

}

export default cartModule